// extracted by mini-css-extract-plugin
export default {"recorder":"AudioStickerRecorder_recorder_hSxZZ","help":"AudioStickerRecorder_help_JUbzk"};